import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { ThemeContext } from "../theme";

export const GamePage = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const { colors } = useContext(ThemeContext)!;

  if (!gameId) {
    console.log("No game found");
    return (
      <div
        className={`min-h-screen ${colors.bgColor} flex items-center justify-center`}
      >
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto mb-4"></div>
          <p className={`${colors.textColor} text-lg`}>Loading game...</p>
        </div>
      </div>
    );
  }



  return (
    <div className={`min-h-screen ${colors.bgColor} p-4`}>
      <div className="container mx-auto max-w-6xl">
        <h1>Game Page</h1>
        <p>Game ID: {gameId}</p>
      </div>
    </div>
  );
};
